import { useRouter } from 'next/router';
import { usePassReviewPostDetail } from '@repository/passReview/usePassReview';
import SideBanner from './sideBanner';
import Contents from './contents';
import Recommend from './recommend';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const PassboardDetail = () => {
  const router = useRouter();
  const { query } = router;
  const { data: reviewData } = usePassReviewPostDetail(Number(query.sn));

  if (!reviewData) return null;

  return (
    <div className={cx('wrapper')}>
      <div className={cx('topArea')}>
        <Contents reviewData={reviewData} />
        <SideBanner />
      </div>

      <Recommend />
    </div>
  );
};

export default PassboardDetail;
